import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'tree-item-editor',
    templateUrl: './tree-item-editor.component.html',
    styleUrls: ['./tree-item-editor.component.css'],
    standalone: false
})
export class TreeItemEditorComponent implements AfterViewInit{
  @Input() value: string;
  @Input() placeholder: string;

  @Output() save = new EventEmitter<string>();

  @ViewChild('inputElement') myInputField: ElementRef;
  ngAfterViewInit() {
    this.myInputField.nativeElement.focus();
  }

}
